import React, { useEffect, useState, useCallback } from "react";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function SolicitudesUsuarios() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [sel, setSel] = useState(null); // solicitud seleccionada (detalle)
  const [approving, setApproving] = useState(false);
  const [q, setQ] = useState("");

  // cancelación
  const [cancelingId, setCancelingId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelBusy, setCancelBusy] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setErr("");
    try {
      const r = await fetch(`${API_BASE}/api/admin/solicitudes`, {
        credentials: "include",
      });
      const j = await r.json();
      if (!r.ok || !j?.ok) throw new Error(j?.msg || "Error al listar");
      const rows = (j.data || []).map((s) => ({
        ...s,
        nombreCompleto: s.nombreCompleto || s.nombres || "",
      }));
      setData(rows);
    } catch (e) {
      setErr(String(e.message || e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const filtered = data.filter((x) => {
    const hay = (s) => String(s || "").toLowerCase().includes(q.toLowerCase());
    return hay(x.nombreCompleto) || hay(x.email) || hay(x.empresa) || hay(x.whatsapp) || hay(x.nit);
  });

  const aprobar = async (id) => {
    if (!id) return;
    const ok = typeof window !== "undefined"
      ? window.confirm("¿Aprobar esta solicitud?")
      : true;
    if (!ok) return;

    try {
      setApproving(true);
      const r = await fetch(`${API_BASE}/api/admin/solicitudes/${id}/aprobar`, {
        method: "POST",
        credentials: "include",
      });
      const j = await r.json();
      if (!j.ok) throw new Error(j.msg || "No se pudo aprobar");
      setData((prev) => prev.filter((x) => x.id !== id));
      if (sel?.id === id) setSel(null);
      if (typeof window !== "undefined") window.alert("✅ Solicitud aprobada y usuario creado.");
    } catch (e) {
      if (typeof window !== "undefined") window.alert("❌ " + (e.message || e));
    } finally {
      setApproving(false);
    }
  };

  const cancelar = async (id) => {
    if (!id) return;
    if (!cancelReason.trim()) {
      return window.alert("Debes indicar un motivo de cancelación.");
    }
    const ok = window.confirm("¿Cancelar esta solicitud? Se notificará por correo al solicitante.");
    if (!ok) return;

    try {
      setCancelBusy(true);
      const r = await fetch(`${API_BASE}/api/admin/solicitudes/${id}/cancelar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ motivo: cancelReason.trim() }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) throw new Error(j?.msg || "No se pudo cancelar");
      setData((prev) => prev.filter((x) => x.id !== id));
      if (sel?.id === id) setSel(null);
      setCancelingId(null);
      setCancelReason("");
      window.alert("✅ Solicitud cancelada. Se envió correo al solicitante.");
    } catch (e) {
      window.alert("❌ " + (e.message || e));
    } finally {
      setCancelBusy(false);
    }
  };

  return (
    <div className="p-6">
      <style>{`
        .card{background:#fff;border:1px solid #e5e7eb;border-radius:14px;padding:16px}
        .btn{padding:8px 14px;border-radius:10px;font-weight:600}
        .btn-light{background:#fff;border:1px solid #e5e7eb}
        .btn-brand{background:#244A9B;color:#fff}
        .btn-danger{background:#dc2626;color:#fff}
      `}</style>

      <h1 className="text-2xl font-bold">Solicitudes de Usuario</h1>
      <p className="text-slate-600 mb-4">Aprueba o cancela las cuentas creadas desde la web.</p>

      <div className="flex items-center gap-3 mb-4">
        <input
          className="border rounded-lg px-3 py-2 w-full max-w-sm"
          placeholder="Buscar por nombre, email, NIT, empresa…"
          value={q} onChange={(e) => setQ(e.target.value)}
        />
        <button className="btn btn-light" onClick={load}>Recargar</button>
      </div>

      {loading ? (
        <div>Cargando…</div>
      ) : err ? (
        <div className="text-red-600">{err}</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {/* listado */}
          <div className="card">
            <div className="text-sm text-slate-500 mb-2">{filtered.length} pendientes</div>
            <div className="divide-y">
              {filtered.map((s) => (
                <div key={s.id} className="py-3">
                  <div className="flex items-start gap-3">
                    <img
                      src={ s.foto || `https://ui-avatars.com/api/?name=${encodeURIComponent(s.nombreCompleto || 'Usuario')}&background=random&color=fff` }
                      className="w-12 h-12 rounded-full object-cover border" alt=""
                    />
                    <div className="flex-1">
                      <div className="font-semibold">{s.nombreCompleto || '—'}</div>
                      <div className="text-sm text-slate-600">{s.email}</div>
                      <div className="text-xs text-slate-500">
                        {s.empresa || "—"} · NIT: {s.nit || "—"} · WA: {s.whatsapp || "—"}
                      </div>
                    </div>
                    <div className="flex flex-col gap-2">
                      <button className="btn btn-light" onClick={() => setSel(s)}>Revisar información</button>
                      <button className="btn btn-brand" onClick={() => aprobar(s.id)} disabled={approving}>
                        {approving ? "Aprobando…" : "Aceptar solicitud"}
                      </button>
                      {cancelingId === s.id ? (
                        <>
                          <input
                            className="border rounded-lg px-2 py-1 text-sm"
                            placeholder="Motivo de cancelación"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                          />
                          <div className="flex gap-2">
                            <button className="btn btn-danger" disabled={cancelBusy} onClick={() => cancelar(s.id)}>
                              {cancelBusy ? 'Cancelando…' : 'Confirmar'}
                            </button>
                            <button className="btn btn-light" onClick={() => { setCancelingId(null); setCancelReason(''); }}>
                              Atrás
                            </button>
                          </div>
                        </>
                      ) : (
                        <button className="btn btn-light" onClick={() => { setCancelingId(s.id); setCancelReason(''); }}>
                          Cancelar solicitud
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              {!filtered.length && (
                <div className="py-8 text-center text-slate-500">No hay solicitudes</div>
              )}
            </div>
          </div>

          {/* detalle */}
          <div className="card">
            <h2 className="font-bold mb-3">Detalle</h2>
            {!sel ? (
              <div className="text-slate-500">Selecciona una solicitud para ver sus datos.</div>
            ) : (
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <img
                    src={ sel.foto || `https://ui-avatars.com/api/?name=${encodeURIComponent(sel.nombreCompleto || 'Usuario')}&background=random&color=fff` }
                    className="w-16 h-16 rounded-full border object-cover" alt=""
                  />
                  <div>
                    <div className="text-lg font-semibold">{sel.nombreCompleto || '—'}</div>
                    <div className="text-sm text-slate-600">
                      {new Date(sel.createdAt || Date.now()).toLocaleString()}
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-3 text-sm">
                  <div><b>Correo:</b> {sel.email}</div>
                  <div><b>Empresa:</b> {sel.empresa || "—"}</div>
                  <div className="md:col-span-2"><b>Dirección:</b> {sel.direccion || "—"}</div>
                  <div><b>WhatsApp:</b> {sel.whatsapp || "—"}</div>
                  <div><b>NIT:</b> {sel.nit || "—"}</div>
                </div>

                {/* acciones detalle */}
                <div className="flex flex-wrap gap-2 pt-2">
                  <button className="btn btn-light" onClick={() => setSel(null)}>Cerrar</button>
                  <button className="btn btn-brand" onClick={() => aprobar(sel.id)} disabled={approving}>
                    {approving ? "Aprobando…" : "Aceptar solicitud"}
                  </button>

                  {cancelingId === sel.id ? (
                    <>
                      <input
                        className="border rounded-lg px-2 py-1 text-sm"
                        placeholder="Motivo de cancelación"
                        value={cancelReason}
                        onChange={(e) => setCancelReason(e.target.value)}
                      />
                      <button className="btn btn-danger" disabled={cancelBusy} onClick={() => cancelar(sel.id)}>
                        {cancelBusy ? 'Cancelando…' : 'Confirmar cancelación'}
                      </button>
                      <button className="btn btn-light" onClick={() => { setCancelingId(null); setCancelReason(''); }}>
                        Atrás
                      </button>
                    </>
                  ) : (
                    <button className="btn btn-light" onClick={() => { setCancelingId(sel.id); setCancelReason(''); }}>
                      Cancelar solicitud
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
